/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoModelsCreateDesignCollection,
    SharedserviceMelcoModelsCreateDesignCollectionFromJSON,
    SharedserviceMelcoModelsCreateDesignCollectionToJSON,
    SharedserviceMelcoModelsDesignCollection,
    SharedserviceMelcoModelsDesignCollectionFromJSON,
    SharedserviceMelcoModelsDesignCollectionToJSON,
    SharedserviceMelcoModelsDesignReferences,
    SharedserviceMelcoModelsDesignReferencesFromJSON,
    SharedserviceMelcoModelsDesignReferencesToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionToJSON,
    SharedserviceMelcoModelsUpdateDesignCollection,
    SharedserviceMelcoModelsUpdateDesignCollectionFromJSON,
    SharedserviceMelcoModelsUpdateDesignCollectionToJSON,
} from '../models';

export interface DesignCollectionsDraftApiDesignCollectionsReferencesRequest {
    id: string;
}

export interface DesignCollectionsDraftApiUserDesignCollectionPublishRequest {
    id: string;
}

export interface DesignCollectionsDraftApiUserDesignCollectionUpdateDraftRequest {
    id: string;
    sharedserviceMelcoModelsUpdateDesignCollection?: SharedserviceMelcoModelsUpdateDesignCollection;
}

export interface DesignCollectionsDraftApiUserDesignCollectionsCreateDraftRequest {
    sharedserviceMelcoModelsCreateDesignCollection?: SharedserviceMelcoModelsCreateDesignCollection;
}

export interface DesignCollectionsDraftApiUserDesignCollectionsDeleteRequest {
    id: string;
    force?: boolean;
}

export interface DesignCollectionsDraftApiUserDesignCollectionsDuplicateDraftRequest {
    id: string;
}

export interface DesignCollectionsDraftApiUserDesignCollectionsGetDefRequest {
    id: string;
    publishState?: string;
}

export interface DesignCollectionsDraftApiUserDesignCollectionsGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
}

export interface DesignCollectionsDraftApiUserDesignCollectionsRevertRequest {
    id: string;
}

/**
 * 
 */
export class DesignCollectionsDraftApi extends runtime.BaseAPI {

    /**
     */
    async designCollectionsReferencesRaw(requestParameters: DesignCollectionsDraftApiDesignCollectionsReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling designCollectionsReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignReferencesFromJSON(jsonValue));
    }

    /**
     */
    async designCollectionsReferences(requestParameters: DesignCollectionsDraftApiDesignCollectionsReferencesRequest): Promise<SharedserviceMelcoModelsDesignReferences> {
        const response = await this.designCollectionsReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionPublishRaw(requestParameters: DesignCollectionsDraftApiUserDesignCollectionPublishRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionPublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}/publish`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionPublish(requestParameters: DesignCollectionsDraftApiUserDesignCollectionPublishRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionPublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionUpdateDraftRaw(requestParameters: DesignCollectionsDraftApiUserDesignCollectionUpdateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionUpdateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/designs/collections/{Id}/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsUpdateDesignCollectionToJSON(requestParameters.sharedserviceMelcoModelsUpdateDesignCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionUpdateDraft(requestParameters: DesignCollectionsDraftApiUserDesignCollectionUpdateDraftRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionUpdateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsCreateDraftRaw(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsCreateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/designs/collections/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsCreateDesignCollectionToJSON(requestParameters.sharedserviceMelcoModelsCreateDesignCollection),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionsCreateDraft(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsCreateDraftRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionsCreateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsDeleteRaw(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignCollectionsDelete(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsDeleteRequest): Promise<void> {
        await this.userDesignCollectionsDeleteRaw(requestParameters);
    }

    /**
     */
    async userDesignCollectionsDuplicateDraftRaw(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsDuplicateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionsDuplicateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}/duplicate/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionsDuplicateDraft(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsDuplicateDraftRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionsDuplicateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsGetDefRaw(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignCollection>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionsGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionsGetDef(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsGetDefRequest): Promise<SharedserviceMelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionsGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsGetListRaw(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsGetListRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollectionFromJSON(jsonValue));
    }

    /**
     */
    async userDesignCollectionsGetList(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsGetListRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsDesignCollection> {
        const response = await this.userDesignCollectionsGetListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignCollectionsRevertRaw(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignCollectionsRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/collections/{Id}/revert`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignCollectionsRevert(requestParameters: DesignCollectionsDraftApiUserDesignCollectionsRevertRequest): Promise<void> {
        await this.userDesignCollectionsRevertRaw(requestParameters);
    }

}
